// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.preview-section[data-v-189ecfcc] {\n  margin-top: 30px;\n}\n.warning-content p[data-v-189ecfcc] {\n  margin: 10px 0;\n  font-size: 14px;\n}\n.warning-content ul[data-v-189ecfcc] {\n  list-style-type: disc;\n}\n.warning-content code[data-v-189ecfcc] {\n  background-color: #f4f4f5;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-family: monospace;\n}\n", ""]);
// Exports
module.exports = exports;
